import _ from 'lodash';
import nfcService from '@/services/nfcService';
import Nfc from '../../model/nfc';

const state = {
  baseUrl: '/nfc',
  nfcs: [],
  pagination: {},
  nfc: null,
  loading: false
};

const actions = {
  list({ dispatch, commit }, { type = 'nfc', query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    commit('setNFCs', { nfcs: [], pagination: {} });

    nfcService
      .list({ type, query })
      .then(response => {
        commit('setNFCs', { nfcs: response.data.rows, pagination: response.data.pagination });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  getOne({ dispatch, commit }, { type = 'nfc', nfcId, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    commit('setNFC', { nfc: {} });

    nfcService
      .getOne({ type, nfcId })
      .then(response => {
        commit('setNFC', { nfc: response.data });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  postOne({ dispatch, commit }, { type = 'nfc', nfc, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    nfcService
      .postOne({ type, nfc })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'bottom-end',
            title: '',
            text: type === 'nfc' ? 'New nfc has been added.' : 'New nfc has been added.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  patchOne({ dispatch, commit }, { type = 'nfc', nfcId, nfc, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    nfcService
      .patchOne({ type, nfcId, newNFC: nfc })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'bottom-end',
            title: '',
            text: type === 'nfc' ? 'NFC has been updated.' : 'NFC has been updated.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  deleteOne({ dispatch, commit }, { type = 'nfc', nfcId, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    nfcService
      .deleteOne({ type, nfcId })
      .then(_response => {
        dispatch('list', { type });
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'bottom-end',
            title: '',
            text: type === 'nfc' ? 'NFC has been deleted.' : 'NFC has been deleted.'
          },
          { root: true }
        );
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  }
};

const getters = {};

const mutations = {
  startRequest(state) {
    state.loading = true;
  },
  requestFailed(state) {
    state.loading = false;
  },
  setNFCs(state, { nfcs, pagination }) {
    let rowNum = pagination.first_row_no;
    state.nfcs = _.map(nfcs, nfc => {
      const newNFC = new Nfc({
        rowNum,
        id: nfc.id,
        idType: nfc.id_type,
        userId: nfc.user_id,
        walletId: nfc.wallet_id,
        systemId: nfc.system_id,
        nfcinfo: nfc.nfcinfo,
        reference: nfc.reference,
        ATQA: nfc.ATQA,
        SAK: nfc.SAK,
        ATR: nfc.ATR,
        UID: nfc.UID,
        amount: nfc.amount,
        status: nfc.status,
        updatedAt: nfc.updated_at
      });

      rowNum -= 1;
      return newNFC;
    });
    state.pagination = pagination;

    state.loading = false;
  },
  setNFC(state, { nfc }) {
    state.nfc = new Nfc({
      id: nfc.id,
      idType: nfc.id_type,
      userId: nfc.user_id,
      walletId: nfc.wallet_id,
      systemId: nfc.system_id,
      nfcinfo: nfc.nfcinfo,
      reference: nfc.reference,
      ATQA: nfc.ATQA,
      SAK: nfc.SAK,
      ATR: nfc.ATR,
      UID: nfc.UID,
      amount: nfc.amount,
      status: nfc.status,
      updatedAt: nfc.updated_at
    });

    state.loading = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
